import { STATUS, useVerifyAction } from '@/providers/VerifyActionProvider';
import { KycCongrats } from './KycCongrats';
import { KycEmailContent } from './KycEmailContent';
import { KycEmailContentSuccess } from './KycEmailContentSuccess';
import { KycWelcome } from './KycWelcome';
export const KycLeftSection: React.FC = () => {
  const {
    status,
    successes
  } = useVerifyAction();
  return <>
      {status === STATUS.REGISTRATION ? <KycWelcome /> : status === STATUS.VERIFY_EMAIL && !successes.has(STATUS.VERIFY_EMAIL) ? <KycEmailContent /> : status === STATUS.VERIFY_EMAIL && successes.has(STATUS.VERIFY_EMAIL) ? <KycEmailContentSuccess /> : status === STATUS.COMPLETE_PROFILE && !successes.has(STATUS.COMPLETE_PROFILE) ? <KycWelcome /> : status === STATUS.ID_VERIFICATION && !successes.has(STATUS.ID_VERIFICATION) ? <KycWelcome /> : status === STATUS.ID_VERIFICATION && successes.has(STATUS.ID_VERIFICATION) ? <KycCongrats /> : null}
    </>;
};